import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';
import { PUBLIC_AREAS } from '../utils/config';

export default function OwnerSubmit({ user, type }) {
  const navigate = useNavigate();
  const isRepair = type === 'repair';

  const [locationType, setLocationType] = useState('home');
  const [publicArea, setPublicArea] = useState('');
  const [images, setImages] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const titleRef = useRef(null);

  const handleImage = (e) => {
    const files = Array.from(e.target.files);
    setImages(prev => [...prev, ...files].slice(0, 5));
    const urls = files.map(f => URL.createObjectURL(f));
    setPreviews(prev => [...prev, ...urls].slice(0, 5));
  };

  const removeImage = (idx) => {
    setImages(prev => prev.filter((_, i) => i !== idx));
    setPreviews(prev => prev.filter((_, i) => i !== idx));
  };

  const handleSubmit = async () => {
    const title = titleRef.current?.value || '';
    if (!title) { alert(isRepair ? '请描述报修问题' : '请填写投诉或建议内容'); return; }
    if (isRepair && locationType === 'public' && !publicArea) { alert('请选择公共区域位置'); return; }

    setLoading(true);
    try {
      const data = new FormData();
      data.append('title', title);
      data.append('source', isRepair ? '业主反应' : '投诉建议');
      data.append('priority', '中');
      data.append('assign_type', 'department');
      data.append('department', '秩序部');

      if (isRepair) {
        data.append('location_type', '公共区域');
        data.append('public_area', locationType === 'home' ? (user.room_no || '业主家中') : publicArea);
      } else {
        data.append('location_type', '公共区域');
        data.append('public_area', '业主反馈');
      }

      images.forEach(img => data.append('images', img));
      await API.post('/tasks', data, { headers: { 'Content-Type': 'multipart/form-data' } });
      alert('提交成功，物业会尽快处理');
      navigate('/owner/records');
    } catch (err) {
      alert(err.response?.data?.message || '提交失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.back} onClick={() => navigate(-1)}>← 返回</button>
        <h2 style={styles.headerTitle}>{isRepair ? '我要报修' : '投诉与建议'}</h2>
        <div style={{width:60}} />
      </div>

      <div style={styles.form}>
        <div style={styles.field}>
          <label style={styles.label}>{isRepair ? '问题描述' : '反馈内容'}</label>
          <textarea ref={titleRef} style={styles.textarea}
            placeholder={isRepair ? '请描述故障情况，如：卫生间水管漏水...' : '请描述您的投诉或建议...'}
            rows={4} defaultValue="" />
        </div>

        {isRepair && (
          <div style={styles.field}>
            <label style={styles.label}>问题位置</label>
            <div style={styles.radioGroup}>
              <button type="button"
                style={{...styles.radioBtn, ...(locationType==='home' ? styles.radioBtnActive : {})}}
                onClick={() => setLocationType('home')}>
                🏠 我的家（{user.room_no || '未设置'}）
              </button>
              <button type="button"
                style={{...styles.radioBtn, ...(locationType==='public' ? styles.radioBtnActive : {})}}
                onClick={() => setLocationType('public')}>
                🏘️ 公共区域
              </button>
            </div>
            {locationType === 'public' && (
              <div style={{...styles.radioGroup, marginTop:'8px'}}>
                {PUBLIC_AREAS.map(a => (
                  <button key={a} type="button"
                    style={{...styles.radioBtn, ...(publicArea===a ? styles.radioBtnActive : {})}}
                    onClick={() => setPublicArea(a)}>{a}</button>
                ))}
              </div>
            )}
          </div>
        )}

        <div style={styles.field}>
          <label style={styles.label}>拍照上传（最多5张，选填）</label>
          <div style={styles.imageArea}>
            {previews.map((url, idx) => (
              <div key={idx} style={styles.imgWrap}>
                <img src={url} style={styles.img} alt="" />
                <button style={styles.imgDel} onClick={() => removeImage(idx)}>×</button>
              </div>
            ))}
            {previews.length < 5 && (
              <label style={styles.uploadBtn}>
                <span style={{fontSize:'26px', color:'#999'}}>📷</span>
                <span style={{fontSize:'12px', color:'#999'}}>添加图片</span>
                <input type="file" accept="image/*" multiple style={{display:'none'}} onChange={handleImage} />
              </label>
            )}
          </div>
        </div>

        <button style={{...styles.submitBtn, opacity: loading ? 0.7 : 1}} onClick={handleSubmit} disabled={loading}>
          {loading ? '提交中...' : '提 交'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', background: '#f5f7fa', paddingBottom: '30px' },
  header: { background: 'linear-gradient(90deg, #1a4a8a, #2d7dd2)', padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, zIndex: 100 },
  back: { background: 'transparent', border: 'none', color: '#fff', fontSize: '16px', cursor: 'pointer' },
  headerTitle: { color: '#fff', margin: 0, fontSize: '18px', fontWeight: 700 },
  form: { padding: '16px' },
  field: { marginBottom: '18px' },
  label: { display: 'block', fontWeight: 600, color: '#333', marginBottom: '8px', fontSize: '15px' },
  textarea: { width: '100%', padding: '12px', border: '1.5px solid #e0e0e0', borderRadius: '8px', fontSize: '15px', resize: 'vertical', boxSizing: 'border-box' },
  radioGroup: { display: 'flex', flexWrap: 'wrap', gap: '8px' },
  radioBtn: { padding: '9px 16px', border: '1.5px solid #e0e0e0', borderRadius: '20px', background: '#fff', fontSize: '14px', cursor: 'pointer', color: '#333' },
  radioBtnActive: { background: '#1a4a8a', color: '#fff', borderColor: '#1a4a8a' },
  imageArea: { display: 'flex', flexWrap: 'wrap', gap: '10px' },
  imgWrap: { position: 'relative', width: '80px', height: '80px' },
  img: { width: '80px', height: '80px', objectFit: 'cover', borderRadius: '8px' },
  imgDel: { position: 'absolute', top: '-6px', right: '-6px', width: '20px', height: '20px', background: '#ff4d4f', color: '#fff', border: 'none', borderRadius: '50%', fontSize: '14px', cursor: 'pointer', lineHeight: '20px', padding: 0, textAlign: 'center' },
  uploadBtn: { width: '80px', height: '80px', border: '1.5px dashed #ccc', borderRadius: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', background: '#fafafa', gap: '4px' },
  submitBtn: { width: '100%', padding: '14px', background: 'linear-gradient(90deg, #1a4a8a, #2d7dd2)', color: '#fff', border: 'none', borderRadius: '10px', fontSize: '17px', fontWeight: 700, cursor: 'pointer', marginTop: '10px' }
};
